import env from '../../../env';
import { KanbanBoardColumnIndewal } from "./columnInstallations/columnIndewal";
import { KanbanBoardColumnNijboer } from "./columnInstallations/columnNijboer";
import { AppClientId } from "../../Shared/constants";
import { KanbanBoardColumnHooikammer } from "./columnInstallations/columnHooikammer";
import { KanbanBoardColumnIDWGMBH } from "./columnInstallations/columnIDWGMBH";
import { KanbanBoardColumnWientjes } from "./columnInstallations/columnWientjes";
import { columnAutohuissalland } from "./columnInstallations/columnAutohuissalland"; 
import { KanbanBoardColumnHiltermann } from "./columnInstallations/columnHiltermann";

let component = KanbanBoardColumnIndewal;
switch (env.clientId) {
  case AppClientId.INDEWAL: component = KanbanBoardColumnIndewal;
    break;
    case AppClientId.IDWLEASE: component = KanbanBoardColumnIndewal;
    break;
  case AppClientId.HARRY_NIJBOER: component = KanbanBoardColumnNijboer;
    break;
  case AppClientId.HOOIKAMMER: component = KanbanBoardColumnHooikammer;
    break;
  case AppClientId.IDW_GMBH: component = KanbanBoardColumnIDWGMBH;
    break;
  case AppClientId.AUTOWIENTJES: component = KanbanBoardColumnWientjes;
    break;
  case AppClientId.AUTOHUISSALLAND: component = columnAutohuissalland;
    break;
    case AppClientId.HILTERMANN: component = KanbanBoardColumnHiltermann;
    break;

}

export const KanbanBoardColumn = component;
